export const CARE_PRODUCT = {
  Plus: 'plus',
  Basic: 'basic',
}

export function isCareEnterprise(productVariantId) {
  return [
    'gid://shopify/ProductVariant/56318759108994',
    'gid://shopify/ProductVariant/56318753505666',
  ].some((item) => item === productVariantId)
}

export function hasCareEnterprise({ type, shopifyId }) {
  if (!type || !shopifyId) return false

  if (type === CARE_PRODUCT.Plus) {
    return [
      'gid://shopify/Product/15002571800962',
      'gid://shopify/Product/14884956897666',
      'gid://shopify/Product/14885045338498',
      'gid://shopify/Product/14921086992770',
      'gid://shopify/Product/14920794014082',
      'gid://shopify/Product/14974606606722',
      'gid://shopify/Product/14974609097090',
      'gid://shopify/Product/14921170715010',
      'gid://shopify/Product/14920794898818',
      'gid://shopify/Product/15167864013186',
      'gid://shopify/Product/14994109923714',
      'gid://shopify/Product/15425161068930',
    ].some((item) => item === shopifyId)
  }

  if (type === CARE_PRODUCT.Basic) {
    return [
      'gid://shopify/Product/8113869291754',
      'gid://shopify/Product/7633952768234',
      'gid://shopify/Product/7631765274858',
      'gid://shopify/Product/8010078453994',
      'gid://shopify/Product/8183239868650',
      'gid://shopify/Product/5831069565088',
      'gid://shopify/Product/8382987436266',
      'gid://shopify/Product/8343154721002',
      'gid://shopify/Product/7631986557162',
      'gid://shopify/Product/8113872109802',
      'gid://shopify/Product/15190897688962',
      'gid://shopify/Product/15191117103490',
      'gid://shopify/Product/15109137826178',
    ].some((item) => item === shopifyId)
  }

  return false
}
